import styled from "styled-components";

export const Container = styled.div`
    background-color: #292926;
	max-width: 400px;
	text-transform: uppercase;
	text-align: center;
	color: #ffffff;
	font-family: 'Poppins', sans-serif;
	font-weight: 800;
	font-size: 12pt;
	padding: 1rem;
	border-radius: 5px;
	margin-bottom: 2rem;
	margin-top: 1rem;
`